import styled from 'styled-components';
import { colors, fontSizes } from 'ui/theme';
import { Cell } from '../../../../components/table';
import { TableColumn } from './constants';

const Name = styled.div`
  font-size: ${fontSizes.s14};
  color: ${colors.textPrimary};
`;

const ID = styled.div`
  font-size: ${fontSizes.s12};
  color: ${colors.textSecondary};
`;

export const MessageTypeCell = (props: { name: string; id: number }) => (
  <Cell columnId={TableColumn.messageType}>
    <Name>{props.name}</Name>
    <ID>ID: {props.id}</ID>
  </Cell>
);
